/**
 *
 * @param {*} number
 * function to check if the inputter param is a num
 * if it is anything other than a number, return 0
 */
const checkNum = number => {
    if (typeof number == "number") {
        return number;
    }
    return 0;
};
/**
 *
 * @param {*} number
 * return a number in format with €10.00. If it is a string, just returns the string. E.G. "FREE"
 */
const formatWithCurrency = number => {
    if (typeof number == "number") {
        return "€" + number.toFixed(2);
    }
    return number;
};

/**
 *
 * @param {*} e
 * takes in an input field and validate to allow only numbers, dot and/or comma
 */
const allowOnlyNumbers = e => {
    const NUMBER_DOT_COMMA = /^[\d,.]*$/;
    const fieldValue = e.target.value;
    const fieldHasCommaOrDot = fieldValue.includes(".") || fieldValue.includes(",");
    const keyIsCommaOrDot = e.key === "." || e.key === ",";

    if (!NUMBER_DOT_COMMA.test(e.key) || (keyIsCommaOrDot && fieldHasCommaOrDot)) e.preventDefault();
    e.target.value = fieldValue.replace(",", ".");
};

export { checkNum, formatWithCurrency, allowOnlyNumbers };
